/** @jsxImportSource @emotion/react */
import { Global } from '@emotion/react';
import { useEffect, useRef, useState } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import VKCommunityMessages from '../../VKCommunityMessages';
import Fonts from '../fonts';
import Branch from './branch';
import Footer from './footer';
import Header from './header';
import S1 from './s1';
import S2 from './s2';
import S3 from './s3';
import S4 from './s4';
import S5 from './s5';
import S6 from './s6';
import S7 from './s7';
import S8 from './s8';
import S9 from './s9';
import Tariffs from './tariffs';
import Video from './video';
import VideoGallery from './video-gallery';

let timer = null;

const Landing = ({
  openPdfModal,
  openVideoGallery,
  closeVideoGallery,
  videoGalleryOpen,
  selectModule,
  currentModuleId,
  openVideo,
  closeVideo,
  videoOpen,
  videoSourceId,
  selectReview,
  currentReviewIndex,
  tariffsOpen,
  openTariffs,
  closeTariffs,
  cases,
  reviews,
  onLoad,
  inDevelopment,
}) => {
  const [activeSection, setActiveSection] = useState(1);

  useEffect(() => {
    onLoad();

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const { width, ref } = useResizeDetector({
    handleHeight: false,
    refreshMode: 'debounce',
    refreshRate: 500,
  });

  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();

  const refMapping = { 1: ref1, 2: ref2, 3: ref3 };

  const scrollTo = n => {
    const bodyTop = document.body.getBoundingClientRect().top;
    const elementPosition = refMapping[n].current.getBoundingClientRect().top;
    const headerHeight = document.querySelector('header').getBoundingClientRect().height;

    window.scrollTo({
      top: elementPosition - bodyTop - headerHeight,
      behavior: 'smooth',
    });
  };

  const findPosition = () => {
    const headerHeight = document.querySelector('header').getBoundingClientRect().height;

    let newActiveSection = 1;

    if (window.scrollY + document.body.clientHeight + 10 >= document.body.scrollHeight) {
      newActiveSection = 4;
    } else {
      newActiveSection =
        +Object.keys(refMapping)
          .reverse()
          .find(n => {
            const refTop = refMapping[n].current.getBoundingClientRect().top;

            return refTop - 3 < headerHeight;
          }) || 0;
    }

    setActiveSection(newActiveSection);
  };

  const handleScroll = () => {
    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(findPosition, 100);
  };

  return (
    <>
      <main ref={ref} css={{ div: { display: 'flex' }, paddingTop: 83 }}>
        {width > 0 && (
          <>
            <Header
              activeSection={activeSection}
              scrollTo={scrollTo}
              width={width}
              openTariffs={openTariffs}
              openVideo={openVideo}
              inDevelopment={inDevelopment}
            />
            <Branch />

            <S1 ref={ref1} openVideo={openVideo} />
            <S2 />
            <S3 openVideo={openVideo} />
            <S4
              width={width}
              openVideoGallery={openVideoGallery}
              selectModule={selectModule}
              currentModuleId={currentModuleId}
            />
            <S5
              ref={ref2}
              width={width}
              selectReview={selectReview}
              currentReviewIndex={currentReviewIndex}
              reviews={reviews}
            />
            <S6 inDevelopment={inDevelopment} />
            <S7 ref={ref3} cases={cases} />
            <S8 />
            <S9 />

            <Footer openPdfModal={openPdfModal} />

            <VKCommunityMessages />
          </>
        )}
      </main>

      {videoGalleryOpen && (
        <VideoGallery
          onClose={closeVideoGallery}
          selectModule={selectModule}
          currentModuleId={currentModuleId}
        />
      )}

      {videoOpen && <Video onClose={closeVideo} videoSourceId={videoSourceId} />}

      {tariffsOpen && <Tariffs onClose={closeTariffs} />}

      <Fonts />
      <Global
        styles={{
          body: { overflowX: 'hidden' },
          '.ant-scrolling-effect': { header: { marginRight: 17 }, '.branch': { left: -98 } },
          '@keyframes pulsate-2': {
            '0%': {
              transform: 'scale(1, 1)',
              opacity: '.5',
            },
            '100%': {
              transform: 'scale(1.17, 1.3)',
              opacity: 0,
            },
          },
        }}
      />
    </>
  );
};

export default Landing;
